import CreateTask from './CreateTask'

export default [CreateTask]
